module.exports = __webpack_public_path__ + "static/media/close.80f2e1e2.svg";